import type { AssetBalanceDto, BalanceDto, PartnersBalanceDto } from '@shared/api/contracts';
import { clampNonNegative } from '@shared/lib/format-amount';
import { getAssetBalanceKey, normalizeAssetBalances } from '@shared/lib/asset-balance';
import type { Balance } from '../model/types';

const decimalOrNull = (value: number | string | null | undefined): string | null => {
  if (value == null || value === '') return null;
  return String(value);
};

const mapAssetBalances = (balances: unknown): AssetBalanceDto[] =>
  normalizeAssetBalances(balances).map((balance) => ({
    ...balance,
    amount: balance.amount,
    bookedAmount: balance.bookedAmount ?? null,
    availableAmount: balance.availableAmount ?? null,
  }));

export const mapBalanceDtoToEntity = (dto: BalanceDto): Balance => ({
  totalBalance: clampNonNegative(dto.total_balance ?? 0),
  reservedBalance: decimalOrNull(dto.reserved_balance),
  availableBalance: decimalOrNull(dto.available_balance),
  autoWithdraw: dto.auto_withdraw ?? null,
  assetBalances: mapAssetBalances(dto.balances),
});

export const mapPartnersBalanceDtoToEntity = (dto: PartnersBalanceDto): Balance => ({
  totalBalance: clampNonNegative(dto.total_balance ?? 0),
  reservedBalance: decimalOrNull(dto.reserved_balance),
  availableBalance: decimalOrNull(dto.available_balance),
  autoWithdraw: null,
  assetBalances: mapAssetBalances(dto.balances),
});

export const getBalanceRowKey = (assetCode: string, network: string): string =>
  getAssetBalanceKey(assetCode, network);
